import { render, staticRenderFns } from "./PronounsSection.vue?vue&type=template&id=c19bfaf4"
import script from "./PronounsSection.vue?vue&type=script&lang=ts"
export * from "./PronounsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports